var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('forgot.success'))+"! ")]),_c('div',{staticClass:"txt"},[_vm._v(" "+_vm._s(_vm.$t('forgot.successTxt'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }